import { useApolloClient } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { Session } from '../../state/Session';
import { useCallback } from 'react';
import { sessionSubject } from '../../state/sessionObservable';
import useBehaviorSubjectState from '../rxjs/useSubjectState';
import { SubNavigatorName } from '../login/useInitialScreen';
import { setSession } from '../../state/preferences';

export const useLogout = () => {
  const { setValue } = useBehaviorSubjectState(sessionSubject);
  const client = useApolloClient();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();

  const logout = useCallback(() => {
    setSession({} as Session);
    setValue({} as Session);
    client.cache.reset();
    navigation.navigate(SubNavigatorName.Login);
  }, [navigation, setValue, client]);

  return { logout };
};
